import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private KEY = CryptoJS.enc.Hex.parse('c604f199ff095b4ced4caf373264e84045f71b384ce39628ee8adca2b27109e8');
  private IV = CryptoJS.enc.Hex.parse('47b5b25d579c0bed815c9166b4f37ee8');

  constructor() { }

  public Encrypt(clearText: string): string {
    // As you're using Encoding.Unicde in .net, we have to use CryptoJS.enc.Utf16LE here.
    return CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf16LE.parse(clearText),
      this.KEY,
      {
        iv: this.IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    ).toString();
  }

  public Decrypt(cipherText: string): string {
    // As you're using Encoding.Unicde in .net, we have to use CryptoJS.enc.Utf16LE here.
    let decrypt = CryptoJS.AES.decrypt(cipherText, this.KEY, {
      iv: this.IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    let utf16String = CryptoJS.enc.Utf16LE.stringify(decrypt);
    return utf16String.replaceAll('\x00', '').replaceAll(/[\u0000-\u001F\u007F-\u009F]/g, '');
  }
}